import { createContext, createRef } from "react";
import { IBoundaryContext } from "./interfaces/IBoundaryContext";

export const BoundaryContext = createContext<IBoundaryContext>({
    element: createRef()
});
